// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__14NHb","col":"styles_col__27s8y"};